import './Cover.scss'

import React, { memo, ReactNode, useCallback, MouseEvent } from 'react'
import { includes } from 'lodash'

import Loading from '../../components/Loading'
import LinkWrapper from '../../components/LinkWrapper'

import { getTranslateValue } from '../../utils/locale'
import { CoverItemFragment } from '../../types/generated'

interface Props {
  item: CoverItemFragment
  backgroundImage: string
  nowLoading: boolean
  children?: ReactNode
  isSlick?: boolean
}

const classNamesWithLink = [
  'Cover__wrapper',
  'Cover__description',
  'Cover__title',
  'Cover__subTitle',
  'Cover__watchButton',
]

export default memo(function Cover({ item, backgroundImage, nowLoading, children, isSlick }: Props) {
  /**
   * OW-462: 이 코드는 LinkWrapper 컴포넌트가 감싸는 영역외에도 최상단 div tag(.Cover)가
   * 클릭되었을때도 LinkWrapper를 클릭한 것처럼 작동해야해서 event delegation을 적용한 것이다.
   * 그래서 이 코드로 인해 Cover__description는 이전처럼 작동하고,
   * 최상단 div tag를 클릭하면 LinkWrapper를 클릭한 것처럼 작동하게 된다.
   */
  const handleCoverClick = useCallback((e: MouseEvent<HTMLDivElement>) => {
    const targetClassName = (e.target as HTMLElement).className
    if (!includes(classNamesWithLink, targetClassName)) {
      return
    }

    (document.querySelector(`${isSlick ? '.slick-current ' : ''}.Cover__link`) as HTMLAnchorElement).click()
    // eslint-disable-next-line
  }, [])

  const handleLinkWrapperClick = useCallback((e: MouseEvent) => e.stopPropagation(), [])

  if (!item) {
    return null
  }

  return (
    <div className="Cover" style={{ backgroundImage }} onClick={handleCoverClick}>
      <div className="Cover__wrapper">
        <Loading visible={nowLoading} />
        <div className="Cover__description">
          <LinkWrapper className="Cover__link" url={item.url} onClick={handleLinkWrapperClick}>
            <h3 className="Cover__title">{getTranslateValue(item, 'title')}</h3>
            <br />
            <p className="Cover__subTitle">{getTranslateValue(item, 'description')}</p>
            <br />
            <button className="Cover__watchButton">{getTranslateValue(item, 'callToAction')}</button>
          </LinkWrapper>
        </div>
        {children}
      </div>
    </div>
  )
})
